import {toast, ToastCard} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export type BeneficiaryRemovedToastProps = {
  toastId: string | number;
  onUndo: () => void;
};

export const BeneficiaryRemovedToast: FC<BeneficiaryRemovedToastProps> = ({toastId, onUndo}) => {
  const {t} = useTranslation('trustAccounts');

  return (
    <ToastCard
      iconName="sollapay:check"
      title={t('view.beneficiaries.removedToast.title')}
      description={t('view.beneficiaries.removedToast.description')}
      action={{label: t('view.beneficiaries.removedToast.undo'), onClick: onUndo}}
      onClose={() => toast.dismiss(toastId)}
      closeLabel={t('view.beneficiaries.toastClose')}
    />
  );
};

/** Duration mirrors the caller's own deferred-deletion timer — see BeneficiariesTabContent. */
export function showBeneficiaryRemovedToast(onUndo: () => void): void {
  toast.custom(id => <BeneficiaryRemovedToast toastId={id} onUndo={onUndo} />, {duration: 4_000});
}
